import BlogSharing from './BlogSharing';

export default BlogSharing;
